<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>欢迎页设置</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="0">
            <el-row type="flex" style="justify-content: right;">
                <el-button type="primary" size="mini" @click="toAddRegion">新增</el-button>
            </el-row>
            <el-table
            :data="welcomes"
            :height="tableHeight"
            size="mini"
            border
            @selection-change="handleSelectionChange"
            ref="tb"
            style="width: 100%">
                <el-table-column  type="selection" width="55"></el-table-column>
                <el-table-column fixed prop="roleName" label="角色" width="100"></el-table-column>
                <el-table-column fixed prop="welcomeContent" label="欢迎内容"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button @click="toUpdate(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10,20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog title="新增欢迎设置" :visible.sync="dialogFormVisible"  append-to-body>
            <el-form :model="addWelcome" ref="addForm" size="mini">
                <el-form-item label-width="120" label="角色" prop="roleCode">
                    <el-select v-model="addWelcome.roleCode" filterable placeholder="请选择">
                        <el-option
                        v-for="item in roles"
                        :key="item.dictCode"
                        :label="item.dictDesc"
                        :value="item.dictCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label-width="120" label="欢迎内容" prop="welcomeContent">
                    <el-input type="textarea" v-model="addWelcome.welcomeContent" clearable :rows="10"></el-input>
                </el-form-item>
                <el-row type="flex" style="justify-content: right;">
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="submitWelcome('addForm')">提交</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-dialog>
        <el-dialog title="修改欢迎设置" :visible.sync="updateDialog"  append-to-body>
            <el-form :model="updateWelcome" ref="updateForm" size="mini">
                <el-form-item label-width="120" label="角色" prop="roleCode">
                    <el-select v-model="updateWelcome.roleCode" filterable placeholder="请选择">
                        <el-option
                        v-for="item in roles"
                        :key="item.dictCode"
                        :label="item.dictDesc"
                        :value="item.dictCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label-width="120" label="欢迎内容" prop="welcomeContent">
                    <el-input type="textarea" v-model="updateWelcome.welcomeContent" clearable :rows="10"></el-input>
                </el-form-item>
                <el-row type="flex" style="justify-content: right;">
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="submitWelcomeUpdate('updateForm')">提交</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
    
</template>

<script>

    export default {
        name:'WelcomeSet',
        data() {
            return {
                welcome: {
                    condition:{
                    },
                    pageNum: 1,
                    pageSize:0
                },
                direction: 'rtl',
                welcomes: [],
                currentPage: 1,
                pageSize:20,
                total:10,
                timer:'',
                tableHeight: "",//表格高度
                tableHeight1: "",//表格高度
                tableHeight2: "",//表格高度
                dialogFormVisible: false,
                addWelcome:{},
                updateDialog: false,
                updateWelcome: {},
                selectedRegion: {},
                roles: [],
            }
        },
        methods: {
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryWelcome();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryWelcome();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryWelcome();
                })
                .catch(() => {});
            },
            queryWelcome() {
                this.welcome.pageNum = this.currentPage;
                this.welcome.pageSize = this.pageSize;
                this.$axios.post("/welcome/find",this.welcome).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.welcomes = res.data.result.list;
                            this.total = res.data.result.total;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            getTableHeight() {
                let tableH = 300; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
                this.tableHeight1 = this.tableHeight/2;
                this.tableHeight2 = this.tableHeight/2 - 10;
            },
            toggleSelection(rows) {
                if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
                } else {
                this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(selection) {
                //this.multipleSelection = val;
                if (selection.length > 1) {
                    this.$refs.tb.clearSelection();
                    this.$refs.tb.toggleRowSelection(selection.pop());
                }else if (selection.length === 1) {
                    this.selectedRegion = selection.pop()
                } else {
                    this.selectedRegion = {}
                }
            },
            toAddRegion() {
                this.dialogFormVisible = true;
                this.addWelcome = {};
            },
            
            submitWelcome(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/welcome/save",this.addWelcome).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message.info(res.data.message);
                                this.dialogFormVisible = false;
                                this.queryWelcome();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                } else {
                    return false;
                }
                });
            },
            submitWelcomeUpdate() {
                this.$axios.post("/welcome/update",this.updateWelcome).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message.info(res.data.message);
                            this.updateDialog = false;
                            this.queryWelcome();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            toUpdate(row) {
                this.updateWelcome = row;
                this.updateDialog = true;
            },
            del(row) {
                this.$confirm('您确认删除此数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post("/welcome/delete",row).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.queryWelcome();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            queryRoles() {
                let condition = {value:"ROLE"};
                this.$axios.post("/dictionary/findByDictType",condition).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.roles = res.data.result;
                        }else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
        },
        mounted() {
            this.queryWelcome();
            this.queryRoles();
        },
        created() {
            this.getTableHeight();
        }
        
    }


</script>

<style scoped>

   .el-row {
       margin-top: 30px;
       text-align: left;
       padding-left: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

</style>
